// extracted by mini-css-extract-plugin
module.exports = {"label":"AvailabilityLabel_label__k5LF0","availableSoon":"AvailabilityLabel_availableSoon__9Rx5V","expiresSoon":"AvailabilityLabel_expiresSoon__qZCqb"};